import { render, staticRenderFns } from "./police.vue?vue&type=template&id=28ab0f2f&scoped=true"
import script from "./police.vue?vue&type=script&lang=js"
export * from "./police.vue?vue&type=script&lang=js"
import style0 from "./police.vue?vue&type=style&index=0&id=28ab0f2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab0f2f",
  null
  
)

export default component.exports